<template lang="pug">
.version-history
    aiq-dialog.modal-editor(:title="$t(`${baseTranslationPath}.version_history`)"
        v-model="showVersions"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        @closed="closeEditor"
        )
        .version-history-list
            .version-history-item(v-for="version in getVersions" :key="version.id")
                .version-history-item-name(@click="openDocument(version)")
                    font-awesome-icon(:icon="getFileType(version)[0]" :class="getFileType(version)[1]")
                    span.title {{ getName(version) }}
                    span.title {{ getVersionLabel(version) }}
                    span.title {{ getCreatedTime(version) }}
</template>
<script>
import GetGlobalSource from '@/libs/mixins/GetGlobalSource';
import get from 'lodash/get';
import dayjs from '@/localPlugins/dayjs';
import { iconClasses } from '../../SmartDrive/smartDriveUtil';

export default {
  name: 'VersionHistory',
  mixins: [GetGlobalSource],
  props: {
    smartControlRecord: {
      type: Object,
      required: true,
    },
    showHistory: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.showVersions = this.showHistory;
  },
  computed: {
    getVersions() {
      return get(this.smartControlRecord, 'versions', []);
    },
  },
  data() {
    return {
      showVersions: true,
      baseTranslationPath:
        'settings_tab.admin_tab.smart_control.control_list_manage',
    };
  },
  emits: ['closeHistory'],
  methods: {
    getName(version) {
      return get(version, 'file.payload.name', '');
    },
    closeEditor() {
      this.showVersions = false;
      this.$emit('closeHistory');
    },
    getFileType(version) {
      const object_type = get(version, 'file.payload.mime', '');
      return iconClasses(object_type);
    },
    getVersionLabel(version) {
      const version_label = get(version, 'label', '');
      return `(Version ${version_label})`;
    },
    getCreatedTime(version) {
      const date = get(version, 'created_at', '');
      return `(${dayjs(date).format('MM/DD/YYYY hh:mm A')})`;
    },
    async openDocument(version) {
      const url = await this.getFileUrl(get(version, 'file.payload'));
      if (url) {
        window.open(url, '_blank');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../SmartDrive/icon.scss";

.version-history-list {
    padding-top: 20px;
    padding-bottom: 20px;
}

.version-history-item-name {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    margin-left: 10px;
    .title {
        margin-left: 10px;
    }
    &:hover {
      color: #4671B3;
      text-decoration: underline;
      font-weight: bold;
    }
}
</style>